// pages/.../WatchBpGuide.jsx
import React, { useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import HeadSub from '../../../../components/comm/HeadSub';
import style from './WatchBpGuide.module.css';
import bigWatch from '../../../../images/common/i_watch_big.svg';
import guide01 from '../../../../images/common/img_watch_guide_01.svg';
import guide02 from '../../../../images/common/img_watch_guide_02.svg';
import guide03 from '../../../../images/common/img_watch_guide_03.svg';
import guide04 from '../../../../images/common/img_watch_guide_04.svg';
import guide05 from '../../../../images/common/img_watch_guide_05.svg';

import biPhone from '../../../../images/common/i_phone_big.svg';
import phoneGuide01 from '../../../../images/common/img_phone_guide_01.svg';
import phoneGuide02 from '../../../../images/common/img_phone_guide_02.svg';
import phoneGuide03 from '../../../../images/common/img_phone_guide_03.svg';


const PHONE_STEPS = [
    { img: phoneGuide01, caption: '① 삼성 헬스 모니터\n앱 실행' },
    { img: phoneGuide02, caption: '② 데이터 접근 권한 확인' },
    { img: phoneGuide03, caption: '③ 권한 허용' },
];

const GUIDE_STEPS = [
    { img: guide01, caption: '① 워치에서 삼성 헬스\n모니터 앱 실행'},
    { img: guide02, caption: '② 혈압'},
    { img: guide03, caption: '③ 측정'},
    { img: guide04, caption: '④ 측정중'},
    { img: guide05, caption: '⑤ 측정 결과'},
];

const WatchBpGuide = () => {
    const navigate = useNavigate();

    const [scrollHintVisible, setScrollHintVisible] = useState(true);
    const [page, setPage] = useState('phone');   // 'phone' | 'watch'

    const handleTouch = () => {
        if (scrollHintVisible) setScrollHintVisible(false);
    };

    const phoneSwiperRef = useRef(null);
    const watchSwiperRef = useRef(null);

    /*
    * 마지막 이미지 뒤에 안내 슬라이드가 하나 더 붙는다.
    * 안내 슬라이드(index === PHONE_STEPS.length)에 도달한 뒤
    * 한 번 더 밀면 다음 가이드로 전환.
    */
    const handlePhoneReachEnd = (sw) => {
        if (sw.activeIndex >= PHONE_STEPS.length) {
            setPage('watch');
            watchSwiperRef.current?.slideTo(1, 0);   // 워치 첫 이미지로
        }
    };

    const handleWatchSlideChange = (sw) => {
        if (sw.activeIndex === 0) {
            setPage('phone');
            phoneSwiperRef.current?.slideTo(0, 0); 
        }
    };

    return (
        <>
            <HeadSub title="워치 혈압 측정 가이드" />

            <div id="sub-content">
                <div className="inner-wrap">

                    <div className={style.stack}>

                        {/* ── 1. 스마트폰 권한 허용 ── */}
                        <div
                            className={style.stackItem}
                            data-active={page === 'phone'}
                            aria-hidden={page !== 'phone'}
                        >
                            <div className={style.topSection}>
                                <div className={style.watchIcon}>
                                    <img src={biPhone} alt="스마트폰 아이콘" />
                                </div>
                                <p className={style.topDesc}>
                                    혈압 데이터 연동을 위해<br />
                                    스마트폰의 삼성 헬스 모니터<br />
                                    앱에서 권한을 허용해주세요.
                                </p>
                            </div>

                            <div
                                className={style.swiperSection}
                                onTouchStart={handleTouch}
                                onClick={handleTouch}
                            >
                                <Swiper
                                    modules={[Pagination]}
                                    pagination={{ clickable: true }}
                                    slidesPerView={2}
                                    centeredSlides
                                    spaceBetween={12}
                                    className={style.swiper}
                                    onSwiper={(sw) => { phoneSwiperRef.current = sw; }}
                                    onSlideChange={handlePhoneReachEnd}
                                >
                                    {PHONE_STEPS.map((step, i) => (
                                        <SwiperSlide key={i}>
                                            <div className={style.slideCard}>
                                                <div className={`${style.slideImg} ${style.slideImgPhone}`}>
                                                    <img src={step.img} alt="스마트폰 가이드 슬라이드" />
                                                </div>
                                                <p className={style.slideCaption}>{step.caption}</p>
                                            </div>
                                        </SwiperSlide>
                                    ))}

                                    {/* 다음 가이드 안내 슬라이드 */}
                                    <SwiperSlide>
                                        
                                            <div className={`${style.slideCard} ${style.slideCardNext}`}>
                                                <div className={`${style.nextCard} ${style.nextCardPhone}`}>
                                                    <span className={style.nextCardArrow} aria-hidden="true" />
                                                    <p>다음 가이드</p>
                                                    <span className={style.nextCardSub}>계속 밀어주세요</span>
                                                </div>
                                            </div>
                                        
                                    </SwiperSlide>
                                </Swiper>

                                {scrollHintVisible && (
                                    <div className={style.scrollHint}>
                                        <div className={style.scrollHintInner}>
                                            <span className={style.scrollArrows}></span>
                                            <span className={style.scrollIcon}></span>
                                            <p>좌우로 스크롤 하세요</p>
                                            <button
                                                className={style.scrollClose}
                                                onClick={(e) => { e.stopPropagation(); setScrollHintVisible(false); }}
                                            >×</button>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>

                        {/* ── 2. 워치 혈압 측정 ── */}
                        <div
                            className={style.stackItem}
                            data-active={page === 'watch'}
                            aria-hidden={page !== 'watch'}
                        >
                            <div className={style.topSection}>
                                <div className={style.watchIcon}>
                                    <img src={bigWatch} alt="워치 시계 아이콘" />
                                </div>
                                <p className={style.topDesc}>
                                    워치를 착용한 상태에서<br />
                                    삼성 헬스 모니터 앱을 실행한 후<br />
                                    혈압 측정을 선택해 주세요.
                                </p>
                            </div>

                            <div className={style.swiperSection}>
                                <Swiper
                                    modules={[Pagination]}
                                    pagination={{ clickable: true }}
                                    slidesPerView={2}
                                    centeredSlides
                                    spaceBetween={12}
                                    initialSlide={1}
                                    className={style.swiper}
                                    onSwiper={(sw) => { watchSwiperRef.current = sw; }}
                                    onSlideChange={handleWatchSlideChange}
                                >

                                    {/* 이전 가이드 안내 슬라이드 */}
                                    <SwiperSlide>
                                        <div className={`${style.slideCard} ${style.slideCardNext}`}>
                                            <div className={`${style.nextCard} ${style.nextCardPhone}`} data-dir="prev">
                                                <span className={style.nextCardArrow} data-dir="prev" aria-hidden="true" />
                                                <p>이전 가이드</p>
                                                <span className={style.nextCardSub}>계속 밀어주세요</span>
                                            </div>
                                        </div>
                                    </SwiperSlide>
                                    {GUIDE_STEPS.map((step, i) => (
                                        <SwiperSlide key={i}>
                                            <div className={style.slideCard}>
                                                <div className={style.slideImg}>
                                                    <img src={step.img} alt="워치 가이드 슬라이드" />
                                                </div>
                                                <p className={style.slideCaption}>{step.caption}</p>
                                            </div>
                                        </SwiperSlide>
                                    ))}
                                </Swiper>
                            </div>

                            <p className={style.notice}>※ 현재 워치 혈압 측정은 갤럭시 워치에서만 지원합니다.</p>
                        </div>

                    </div>

                    {/* 페이지 인디케이터 */}
                    {/* <div className={style.pageDots}>
                        <span className={style.pageDot} data-active={page === 'phone'} />
                        <span className={style.pageDot} data-active={page === 'watch'} />
                    </div> */}

                </div>
            </div>

            {/* 하단 버튼 */}
            <div className="bottom-fixed-box">
                <div className="inner-box" data-bg-color="transparent">
                    <div className="btn-layout" data-btn-num="1">
                        <button className="btn" data-btn-type="fill-main" data-btn-size="lg"
                            onClick={() => navigate(-1)}>
                            <span>확인</span>
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
};

export default WatchBpGuide;